export const GENERAL_SOCIAL_LINKS = {
  INSTAGRAM: 'https://www.instagram.com/official.dpd.uk/?hl=en',
  LINKEDIN: 'https://uk.linkedin.com/company/dpdgroupuk',
};
